<script>
import _slug from "~/pages/_lang/influencer/widget/_slug"
export default _slug
</script>
